<template>
    <div class="section__service">
        <div class="section__service__icon" :style="{ backgroundImage: 'url(' + require(`../../assets/${icon}.png`) + ')' }"></div>
        <span class="section__service__text">{{ text }}</span>
    </div>
</template>

<script>
    export default {
        name: 'Service',
        props: {
            icon: String,
            text: String
        }
    }
</script>

<style lang="scss" scoped>

    .section {

        &__service {
            display: flex;
            justify-content: center;
            flex-wrap: wrap;
            margin-bottom: 6rem;

            &__icon {
                width: 16rem;
                height: 16rem;
                border-radius: 50%;
                background-color: #385dae;
                background-size: cover;
            }

            &__text {
                display: block;
                width: 100%;
                margin-top: 3rem;
                text-align: center;
                font-size: 2.2rem;
                color: #666;
            }
        }
    }

    @media (max-width: 767px) {

        .section {

            &__service {
                margin-bottom: 3rem;

                &__icon {
                    width: 13rem;
                    height: 13rem;
                }

                &__text {
                    font-size: 1.8rem;
                }
            }

            &--services {
                padding-bottom: 0;
            }
        }
    }

    @media (max-width: 499px) {

        .section {

            &__service {

                &__icon {
                    width: 10rem;
                    height: 10rem;
                }
            }
        }
    }

</style>